export default Object.freeze({
  GeneralSupport: 1,
});
